export const guarantorEmploymentDetailsAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_GUARANTOR_EMPLOYMENT_DETAILS":
      return action.data;

    default:
      return state;
  }
};
